import { useAppDispatch } from "app/hooks"
import { ActorType } from "features/new-actor/enums/actorType"
import { NaturalPersonFormValues } from "features/new-actor/types/optim/naturalPersonFormValues"
import { FormikProps } from "formik"
import { useDialog } from "hooks/useDialog"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"

export const useUpiContactForm = (
  handleSubmit: (contact: NaturalPersonFormValues) => void,
  deleteContact?: (id: string) => void,
  pendingContact?: NaturalPersonFormValues) => {
  const dispatch = useAppDispatch()
  const [isFormValid, setIsFormValid] = useState(false);
  const { setDialogActions, closeDialog } = useDialog()
  const formikRef = useRef<FormikProps<NaturalPersonFormValues>>(null);

  useEffect(() => {
    const baseActions = {
      closeLabel: "COMMON.CANCEL",
      submitLabel: "COMMON.VALIDATE",
      submitDisabled: !isFormValid,
      onSubmit: () => {
        formikRef.current?.submitForm()
        closeDialog()
      },
    }

    const contactId = pendingContact && pendingContact.id
    if (contactId && deleteContact) {
      setDialogActions({
        ...baseActions,
      })
      return
    }

    if (formikRef.current) {
      setDialogActions(baseActions)
    }
  }, [
    dispatch,
    pendingContact,
    formikRef,
    isFormValid,
    setDialogActions,
    deleteContact,
    closeDialog
  ])

  const editConfig = useMemo(() => {
    if (!pendingContact)
      return
    const formValues = pendingContact as NaturalPersonFormValues
    return {
      initialValues: {
        [ActorType.Natural]: formValues
      },
      initialData: formValues,
      onSubmit: async (values: Partial<NaturalPersonFormValues>, initialData: any) => {
        if (values.id) {
          handleSubmit(values as NaturalPersonFormValues)
        }
      }
    }
  }, [pendingContact, handleSubmit]);

  const handleValidationChange = useCallback((isValid: boolean) => {
    setIsFormValid(isValid);
  }, []);

  return {
    deleteContact,
    editConfig,
    formikRef,
    pendingContact,
    handleValidationChange
  }
}
